// Remarque de Louka du 30/09 : la citation d'un document televerse (dossier du RAG) n'avait pas de
// lien, et l'ancre vide en target _blank ouvrait la page de Dust elle-meme dans un nouvel onglet.
// Trois destinations : aucune (pas de lien), l'app (meme origine, hors du chat : le pont donne
// aux documents un lien /documents?ouvrir=<id>, que l'app ouvre dans sa visionneuse ; en mode
// integre le parent navigue, sinon nouvel onglet), externe (site web : nouvel onglet).
export type DestinationCitation =
  | { type: "aucune" }
  | { type: "app"; route: string }
  | { type: "externe"; href: string };

export function destinationCitation(
  href: string | null | undefined,
  origine: string,
  baseDuChat: string
): DestinationCitation {
  // Seule une URL absolue http(s) compte : un lien vide, relatif ou d'un autre schema ne mene
  // nulle part (une chaine relative deviendrait sinon une route de l'app).
  if (!href || !/^https?:\/\//i.test(href)) {
    return { type: "aucune" };
  }
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return { type: "aucune" };
  }
  const base = baseDuChat.replace(/\/$/, "");
  const dansLeChat =
    base !== "" &&
    (url.pathname === base || url.pathname.startsWith(`${base}/`));
  if (url.origin === origine && !dansLeChat) {
    return { type: "app", route: `${url.pathname}${url.search}` };
  }
  // RAG Dust (01/10) : un document depose dans un dossier a pour lien son fichier d'origine
  // (<base>/api/w/<espace>/files/<fichier>) ; sans action, la route redirige vers un telechargement.
  // On l'ouvre en lecture (le PDF s'affiche dans l'onglet).
  if (
    url.origin === origine &&
    base !== "" &&
    new RegExp(`^${base}/api/w/[^/]+/files/[^/]+$`).test(url.pathname)
  ) {
    url.searchParams.set("action", "view");
  }
  return { type: "externe", href: url.toString() };
}

/** Le chemin de base de la SPA (« /chat »), lu dans NEXT_PUBLIC_DUST_APP_URL ; vide si inconnu. */
export function baseDuChat(appUrl: string | undefined): string {
  if (!appUrl) {
    return "";
  }
  try {
    return new URL(appUrl).pathname.replace(/\/$/, "");
  } catch {
    return "";
  }
}
